import { Quill } from 'react-quill';

const Inline = Quill.import('blots/inline');
const BlockEmbed = Quill.import('blots/block/embed');

class DividerTitle extends Inline {
  static create(value) {
    const node = super.create(value);
    return node;
  }
}
DividerTitle.className = 'dividertitle';
DividerTitle.blotName = 'dividertitle';
DividerTitle.tagName = 'div';

class DividerLine extends BlockEmbed {
  static create(value) {
    const node = super.create(value);
    node.setAttribute('class', 'dividerline');
    return node;
  }
}
DividerLine.blotName = 'dividerline';
DividerLine.tagName = 'hr';

export { DividerTitle, DividerLine };
